import { PILL_HEIGHT_STYLE } from './pill-positioning';

export const PillV2LabelHover = ({ label, labelTextHover }: { label?: string; labelTextHover?: string }) => {
  if (label && !labelTextHover) {
    return (
      <div className="u-flex u-flexAlignItemsCenter">
        {/* set lineHeight to 24px to match the height of the icons in secondary section and / or pill */}
        <span className="u-textNoWrap u-text-sm-weak u-textBold" style={PILL_HEIGHT_STYLE}>
          {label}
        </span>
      </div>
    );
  }

  if (label && labelTextHover) {
    // set lineHeight to 24px to match the height of the icons in secondary section and / or pill
    return (
      <div className="pill-v2--has-hover-text u-grid" style={{ gridTemplateColumns: 'max-content' }}>
        <span
          className="pill-v2--text u-textNoWrap u-text-sm-weak u-textBold"
          style={{ ...PILL_HEIGHT_STYLE, gridColumn: '1', gridRow: '1' }}
        >
          {label}
        </span>
        {labelTextHover && (
          <span
            className="pill-v2--hover-text u-textNoWrap u-text-sm-weak u-textBold"
            style={{
              ...PILL_HEIGHT_STYLE,
              gridColumn: '1',
              gridRow: '1',
              alignSelf: 'start',
              justifySelf: 'center',
            }}
          >
            {labelTextHover}
          </span>
        )}
      </div>
    );
  }

  return null;
};
